import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import Select from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/Select';
import { List } from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  View,
} from '@uncinc/react-drupal-core';

import {
  getVocabulary,
} from '../../../../store/actions/UI';

const VACANCY_TYPE_VOLUNTEER_TID = 392;
const VACANCY_EMPLOYMENT_TYPE_DAY_WORK_TID = 393;

const VacanciesPaidOverview = ({ display }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({});


  useEffect(() => {
    dispatch(getVocabulary('vacancy_types'));
    dispatch(getVocabulary('locations'));
  }, [dispatch]);
  const vacancyTerms = useSelector((state) => state.getIn(['uiInternal', 'vocabularies', 'vacancy_types'], List()));
  const mappedVacancyTerms = List([{ value: 0, label: t('general.all') }])
    .merge(vacancyTerms.map((term) => {

      return {
        value: term.getIn(['tid', 0, 'value']),
        label: term.getIn(['name', 0, 'value']),
      };
    })).filter((vacancyType) => vacancyType.value !== VACANCY_TYPE_VOLUNTEER_TID && vacancyType.value !== VACANCY_EMPLOYMENT_TYPE_DAY_WORK_TID);

  const onChangeType = (e) => {
    if (e === 0) setFilters((state) => (delete state.field_vacancy_type_target_id));
    else setFilters((state) => ({ ...state, field_vacancy_type_target_id: e }));
    setCurrentPage(0);
  };

  return (
    <Container className="ParagraphContentOverview">
      <FormikWrapper initialValues={{ type: 0, location: 0 }}>
        <div className="row">
          <div className="col-md-6">
            <Select
              title={t('vacancy.what_to_do')}
              fieldName="type"
              placeholder={t('vacancy.placeholder_input_type')}
              options={mappedVacancyTerms.toArray()}
              className="Select"
              classNamePrefix="Select"
              onChange={(e) => {
                onChangeType(e);
                setCurrentPage(0);
              }}
            />
          </div>

        </div>
      </FormikWrapper>
      <View
        id="content_overview"
        display={display}
        page={currentPage}
        setCurrentPage={setCurrentPage}
        type="vacancies_paid"
        filters={filters}
      />
    </Container>
  );
};

export default VacanciesPaidOverview;
